import { TChatMessage, TChatMessagePayload } from '@/redux/services/webinarsApi'
import { useEffect, useLayoutEffect, useRef } from 'react'
import io from 'socket.io-client'

export const useChatSocket = (processNewMessage: (data: TChatMessage) => void) => {
    const socket = io(`${process.env.NEXT_PUBLIC_CHAT_ENDPOINT}`)
    useEffect(() => {
        const onMessage = (data: TChatMessage) => {
            processNewMessage(data)
        }

        socket.on('onMessage', onMessage)

        return () => {
            socket.off('onMessage', onMessage)
        }
    }, [])

    const sendMessage = (payload: TChatMessagePayload) => {
        socket.emit('newMessage', JSON.stringify(payload))
    }

    return { socket, sendMessage }
}

export const useChatScroll = <T, E extends HTMLElement>(dep: T): React.MutableRefObject<E> => {
    const ref = useRef<E | null>(null)

    useLayoutEffect(() => {
        if (!ref.current) return
        ref.current.scrollTop = ref.current.scrollHeight
    }, [dep])

    return ref
}
